import React, { useEffect } from "react";

import { toast } from "react-hot-toast";
import { Navigate, Outlet } from "react-router-dom";

import { getTranslation } from "../utils/helper";

const PrivateRoute = () => {
  const isAuthenticated =
    localStorage.getItem("authSession") == null ? false : true;
  useEffect(() => {
    const translation = getTranslation("LOBBY.LOGIN_TO_CONTINUE");
    if (!isAuthenticated && translation) {
      toast.error(translation, {
        id: translation
      });
    }
  }, [isAuthenticated]);

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
